import { Reducer } from 'redux';
import { IConflictHistoryState } from './types';
import { StudentActionTypes } from '../types';

const initialState: IConflictHistoryState = {};

const reducer: Reducer<IConflictHistoryState> = (state = initialState, action): IConflictHistoryState => {
  switch (action.type) {
    case StudentActionTypes.GET_STUDENT_RECORD_SUCCESS:
      return {
        ...initialState,
        ...action.payload.student.conflictHistory
      };
    default:
      return state;
  }
};

export { reducer as conflictHistoryReducer };
